<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt"><strong>DOONESBURY</strong> is distributed internationally by Universal Uclick.</p>
<p class="crt"><strong><em>Tee Time in Berzerkistan</em></strong> copyright © 2009 by G. B. Trudeau. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. For information, write Andrews McMeel Publishing, LLC, an Andrews McMeel Universal company, 1130 Walnut Street, Kansas City, Missouri 64106.</p>
<p class="crt">E-ISBN: 978-0-7407-9884-9</p>
<p class="crt">Library of Congress Control Number: 2009922833</p>
<p class="crt"><a class="pubhlink" href="http://www.andrewsmcmeel.com" target="_blank">www.andrewsmcmeel.com</a></p>
<p class="center">    <strong><em>DOONESBURY</em> may be viewed on the Internet at</strong><br/><a class="pubhlink" href="http://www.doonesbury.com" target="_blank">www.doonesbury.com</a> and <a class="pubhlink" href="http://www.GoComics.com" target="_blank">www.GoComics.com</a></p>
<div class="textbox">
<p class="center"><strong>ATTENTION: SCHOOLS AND BUSINESSES</strong></p>
<p class="nonindent05">Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please write to: Special Sales Department, Andrews McMeel Publishing, LLC, 1130 Walnut Street, Kansas City, Missouri 64106.<br/><a class="pubhlink" href="mailto:specialsales@amuniversal.com">specialsales@amuniversal.com</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740798849_epub_cop_r1.vue?5a082e2a